<div class="hx-app-switcher__container">
  <!-- Toggle Button with Popover -->
  <span class="hx-app-switcher__toggle-tooltip-wrapper" [hxTooltip]="collapsed() ? panelTitle() : ''" position="right">
    <button
      #triggerButton
      class="hx-app-switcher__toggle"
      [class.hx-app-switcher__toggle--collapsed]="collapsed()"
      [attr.aria-label]="panelTitle()"
      [disabled]="isDisabled()"
      [hxPopover]="popoverContent"
      [trigger]="'click'"
      [position]="popoverPosition()"
      [backdrop]="true"
      [appearance]="'default'"
      [cssStyle]="collapsed() ? 'hx-app-switcher-popover collapsed-offset' : 'hx-app-switcher-popover'"
      (click)="openPopover()">
      <hx-icon [svgIcon]="toggleIcon()" class="hx-app-switcher__toggle-icon"></hx-icon>
      @if (!collapsed()) {
        <span class="hx-app-switcher__toggle-label">{{ panelTitle() }}</span>
      }
    </button>
  </span>

  <!-- Popover Content Template -->
  <ng-template #popoverContent>
    <div class="hx-app-switcher__popover-content" [class.hx-app-switcher__popover-content--collapsed]="collapsed()">
      <!-- Popover Header with Close -->
      <div class="hx-app-switcher__popover-header" [class.hx-app-switcher__popover-header--collapsed]="collapsed()">
        <div
          class="hx-app-switcher__popover-title"
          role="button"
          [attr.aria-label]="'Close ' + panelTitle()"
          [attr.tabindex]="isDisabled() ? -1 : 0"
          (click)="closePopover()"
          (keydown)="handlePopoverHeaderKeydown($event)">
          <hx-icon [svgIcon]="toggleIcon()" class="hx-app-switcher__popover-icon"></hx-icon>
          @if (!collapsed()) {
            <span>{{ panelTitle() }}</span>
          }
        </div>
      </div>

      <!-- App Grid -->
      <div class="hx-app-switcher__grid" role="menu" [class.hx-app-switcher__grid--collapsed]="collapsed()">
        @for (app of apps(); track app.url) {
          <div
            class="hx-app-switcher__item"
            [class.hx-app-switcher__item--active]="app.active"
            role="menuitem"
            [attr.aria-label]="app.name"
            [attr.title]="app.url ? app.name + ' (' + app.url + ')' : app.name"
            [attr.tabindex]="isDisabled() ? -1 : 0"
            (click)="handleAppClick(app, $event)"
            (keydown)="handleKeyDown(app, $event)">
            <!-- App Icon/Logo -->
            <div class="hx-app-switcher__item-icon">
              @if (app.logoType === 'product' && app.logoProduct) {
                <hx-logo type="product" [product]="app.logoProduct" size="medium" [hoverEffect]="true"></hx-logo>
              }
            </div>

            <!-- App Details -->
            @if (!collapsed()) {
              <div class="hx-app-switcher__item-content">
                <span class="hx-app-switcher__item-name">{{ app.name }}</span>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </ng-template>
</div>
